import React, {
  FC,
  memo,
  useState,
  useCallback,
}                                 from 'react';
import { IIntranetUser }          from '@typings/manageIntranetUsers';
import { EUserStatus }            from '@enums/common';
import { parseRecords }           from '@utils/commonFunctions';
import { useFetchIntraUsersList } from '@modules/manageIntranetUsers/queries/intranetUsersQueries';
import { useChangeUserStatus }    from '@modules/registeredBidders/queries/registeredBiddersQueries';
import { IntranetUsersListPage }  from '@modules/manageIntranetUsers/pages/IntranetUsersListPage';

interface IProps {
  isSuperAdmin : boolean;
  onAddNewUser : () => void;
}
const IntranetUsersList: FC<IProps> = ({ isSuperAdmin, onAddNewUser }) => {
  const [intraUsersList, setIntraUsersList] = useState<IIntranetUser[]>([]);
  const [totalCount, setTotalCount]         = useState<number>(0);
  const [currentPage, setCurrentPage]       = useState<number>(0);

  // #region API INTEGRATION
  const { isLoading } = useFetchIntraUsersList(
    currentPage,
    {
      onSuccess: (data) => {
        const list: IIntranetUser[] = parseRecords<IIntranetUser>(data);

        setIntraUsersList(list);
        setTotalCount(data.totalRecordsFound);
      },
    },
  );

  const { mutateAsync: changeIntraUserStatus } = useChangeUserStatus();
  // #endergion

  const onChangeStatus = useCallback(
    async (id: string, status: EUserStatus) => {
      await changeIntraUserStatus({ id, status });

      setIntraUsersList((prev) => prev.map((intraUser) => (intraUser.id === id
        ? { ...intraUser, status }
        : intraUser)));
    },
    [changeIntraUserStatus],
  );

  const onChangePage = useCallback(
    (page: number): void => {
      setCurrentPage(page);

      window.scrollTo({
        top      : 0,
        left     : 0,
        behavior : 'auto', // 'smooth',
      });
    },
    [],
  );

  return (
    <IntranetUsersListPage
      intranetUsers      = {intraUsersList}
      totalUsersCount    = {totalCount}
      isLoading          = {isLoading}
      currentPage        = {currentPage}
      isSuperAdmin       = {isSuperAdmin}
      handleAddNewUser   = {onAddNewUser}
      handleChangePage   = {onChangePage}
      handleChangeStatus = {onChangeStatus}
    />
  );
};

export const IntranetUsersListContainer = memo(IntranetUsersList);
